import React, { FunctionComponent } from 'react'

import { SimpleContainerBox } from '../../../base/components/Container/SimpleBox'
import Breadcrumb from '../../../base/components/Template/Breadcrumb/Breadcrumb'
import { articuloRoutesMap } from '../articuloRoutes'
import ArticuloListado from './listado/ArticuloListado'

interface OwnProps {}

type Props = OwnProps

/**
 * Gestion o pagina principal para gestionar los articulo
 * @constructor
 */
const ArticuloGestion: FunctionComponent<Props> = () => {
  return (
    <SimpleContainerBox>
      <Breadcrumb routeSegments={[articuloRoutesMap.gestion]} />
      <ArticuloListado />
    </SimpleContainerBox>
  )
}

export default ArticuloGestion
